//Tipos
import { Axios } from "../../service/serviceBasic";
import { toast } from "react-toastify";
import { CHANGE_DADOS_INICIAIAS_PJ_VALUE_FORM } from "./types";

import { SET_MESSAGE_CONCLUSAO } from "./../conclusao/types";

import {
  converterObjActionForObjReduceDadosIniciaisPj,
  removeMask,
} from "../../helper/converter";

import {
  LOADING_DADOS_INICIAIAS_PJ_CNPJ,
  SET_DADOS_INICIAIAS_PJ_CNPJ,
  ERROR_DADOS_INICIAIAS_PJ_CNPJ,
  LOADING_DADOS_INICIAIAS_PJ_CODIGO_GERENTE,
  SET_DADOS_INICIAIAS_PJ_CODIGO_GERENTE,
  ERROR_DADOS_INICIAIAS_PJ_CODIGO_GERENTE,
  SET_DADOS_INICIAIAS_PJ_CNAE,
  LOADING_DADOS_INICIAIAS_PJ_CNAE,
  ERROR_DADOS_INICIAIAS_PJ_CNAE,
  HANDLER_CHANGE_DADOS_INICIAIS_PJ_CNAE,
  SET_CODIGO_GERENTE_VIA_LINK_PJ,
  LOADING_DADOS_INICIAIAS_PJ_NOME_GERENTE,
  ERROR_DADOS_INICIAIAS_PJ_NOME_GERENTE,
  SET_ID_DDIPAIS_DADOS_INICIAIS_PJ
} from './types';

export const changeDadosIniciaisPJValueForm = (name, value) => (
  dispatch,
  getState
) => {
  let { dadosIniciaisPJReducer } = getState();
  let formPJValues = dadosIniciaisPJReducer.formPJ;

  if (name.name && name.name === 'dadosIniciais_cnae') 
    formPJValues[name.name] = name.value;
  else
    formPJValues[name] = value;

  dispatch({
    type: CHANGE_DADOS_INICIAIAS_PJ_VALUE_FORM,
    payload: formPJValues,
  });
};

const loadingDadosIniciaisExisteCnpjAction = (flag) => ({
  type: LOADING_DADOS_INICIAIAS_PJ_CNPJ,
  payload: flag,
});
const seDadosIniciaisExisteCnpjAction = (existe) => ({
  type: SET_DADOS_INICIAIAS_PJ_CNPJ,
  payload: existe,
});

const seDadosIniciaisConclusaoCnpjAction = (message) => ({
  type: SET_MESSAGE_CONCLUSAO,
  payload: {
    icon: "fa-cicle",
    title: "O CNPJ informado já existe em nosso sistema.",
    discription:
      "Faça o login ou caso você tenha esquecido a sua senha, vá  para esqueci minha senha.",
  },
});

const setErrorDadosIniciaisExisteCnpj = (existe) => ({
  type: ERROR_DADOS_INICIAIAS_PJ_CNPJ,
  payload: existe,
});

export const resetDadosIniciaisPJ_NomeGerenteAction = () => (
  dispatch,
  getState
) => {
  let { dadosIniciaisPJReducer } = getState();
  let formPJValues = dadosIniciaisPJReducer.formPJ;

  formPJValues["dadosIniciais_nomeGerente"] = "";
  dispatch({
    type: CHANGE_DADOS_INICIAIAS_PJ_VALUE_FORM,
    payload: formPJValues,
  });
};

export const getDadosIniciaisPJGerenteAction = (value, query = false) => (
  dispatch,
  getState
) => {
  let { dadosIniciaisPJReducer } = getState();
  let formPJValues = dadosIniciaisPJReducer.formPJ;

  let request = {
    IdGerente: value,
  };
  dispatch(loadingDadosIniciaisCodigoGerenteAction(true));
  return Axios.post("v1/basico/gerente/obterDadosGerente", request)
    .then((response) => {
      formPJValues["dadosIniciais_nomeGerente"] = response.data.Nome;
      dispatch({
        type: CHANGE_DADOS_INICIAIAS_PJ_VALUE_FORM,
        payload: formPJValues,
      });
      if (query) {
        dispatch({
          type: SET_CODIGO_GERENTE_VIA_LINK_PJ,
          payload: true,
        });
      }
      dispatch(setErrorDadosIniciaisCodigoGerenteAction(""));
    })
    .catch((error) => {
      dispatch(setErrorDadosIniciaisCodigoGerenteAction(error.message));
      dispatch(resetDadosIniciaisPJ_NomeGerenteAction());
    })
    .finally(() => {
      dispatch(loadingDadosIniciaisCodigoGerenteAction(false));
    });
};

const loadingDadosIniciaisCodigoGerenteAction = (flag) => ({
  type: LOADING_DADOS_INICIAIAS_PJ_CODIGO_GERENTE,
  payload: flag,
});
const setErrorDadosIniciaisCodigoGerenteAction = (message) => ({
  type: ERROR_DADOS_INICIAIAS_PJ_CODIGO_GERENTE,
  payload: message,
});

const loadingDadosIniciaisNomeGerenteAction = (flag) => ({
  type: LOADING_DADOS_INICIAIAS_PJ_NOME_GERENTE,
  payload: flag,
});
const setErrorDadosIniciaisNomeGerenteAction = (message) => ({
  type: ERROR_DADOS_INICIAIAS_PJ_NOME_GERENTE,
  payload: message,
});

export const getDadosIniciaisExisteCnpjAction = (dadosIniciais_Cnpj) => (
  dispatch,
  getState
) => {
  let { tipoCadastroReducer } = getState();
  let tipoPessoaId = 0;
  switch (tipoCadastroReducer.tipoPessoaValue) {
    case "PessoaFisica":
      tipoPessoaId = 1;
      break;
    case "PessoaJuridica":
      tipoPessoaId = 2;
      break;
    case "PessoaEstrangeira":
      tipoPessoaId = 3;
      break;
    default:
  }
  dadosIniciais_Cnpj = removeMask(dadosIniciais_Cnpj);

  let resultConverter = converterObjActionForObjReduceDadosIniciaisPj(
    dadosIniciais_Cnpj,
    tipoPessoaId
  );

  dispatch(loadingDadosIniciaisExisteCnpjAction(true));
  return Axios.post("v1/basico/pessoa/verificaDocumento", resultConverter)
    .then(({ data }) => {
      // if (data.Existe) {
      //   dispatch(seDadosIniciaisConclusaoCnpjAction(data));
      // }
      dispatch(seDadosIniciaisExisteCnpjAction(data.Existe));
    })
    .catch((error) => {
      toast.warn("Tente novamente, ou dirija-se a uma loja da B&T Câmbio", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "ui-alert-toast",
      });
      dispatch(setErrorDadosIniciaisExisteCnpj(error.message));
    })
    .finally(() => {
      dispatch(loadingDadosIniciaisExisteCnpjAction(false))
    })
}


const loadingListDadosIniciaisPJCNAEAction = flag => ({
  type:LOADING_DADOS_INICIAIAS_PJ_CNAE,
  payload: flag
})
export const setListDadosIniciaisPJCNAEAction = list => ({
  type: SET_DADOS_INICIAIAS_PJ_CNAE,
  payload: list
})

const setErrorListDadosIniciaisPJCNAE = message => ({
  type: ERROR_DADOS_INICIAIAS_PJ_CNAE,
  payload: message
})

export const handleChangeDadosIniciaisPJCNAE = value => ({
  type: HANDLER_CHANGE_DADOS_INICIAIS_PJ_CNAE,
  payload: value
})

export const resetListCNAE = () => dispatch => {
  dispatch(setListDadosIniciaisPJCNAEAction([]));
  const dataCnae = {
    value: ''
  }
  dispatch(handleChangeDadosIniciaisPJCNAE(dataCnae));
}

export const setIdDDIPaisDadosIniciaisPJ = (id) => dispatch => {
  dispatch({
    type: SET_ID_DDIPAIS_DADOS_INICIAIS_PJ,
    payload: id,
  }); 
}

export const getListDadosIniciaisPJCNAEAction = (value) => (dispatch, getState) => {
  // let {dadosIniciaisPJReducer} = getState;
  // let cnae = dadosIniciaisPJReducer.formPJ.dadosIniciais_cnae;
  dispatch(loadingListDadosIniciaisPJCNAEAction(true))

  return Axios.post('v1/basico/pessoa/listarCNAEs', { Cnae: value })
    .then(response => {
      dispatch(setListDadosIniciaisPJCNAEAction(response.data));
    })
    .catch(error => {
      toast.warn("Tente novamente, ou dirija-se a uma loja da B&T Câmbio", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "ui-alert-toast"
      });
      dispatch(setErrorListDadosIniciaisPJCNAE(error.message))
    })
    .finally(() => {
      dispatch(loadingListDadosIniciaisPJCNAEAction(false))
    })
}
